import { Vmid } from '@salescore/client-redux'
import { t } from 'i18next'
import { createContext, type ReactElement, useContext, useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'

/**
 * View Mount ID (vmid) を提供するための React コンテキスト
 * - VmidContext.Provider: VmidContextProvider からのみ呼ばれるようにする
 * - useContext(VmidContext): useVmid からのみ呼ばれるようにする
 */
const VmidContext = createContext<Vmid | undefined>(undefined)

/**
 * View Mount ID を生成してコンテクストを提供するコンポーネント
 */
export const VmidContextProvider = ({ children }: { children: ReactElement }): ReactElement => {
  const vmid = useMemo(() => Vmid(uuidv4()), [])
  return <VmidContext.Provider value={vmid}>{children}</VmidContext.Provider>
}

/**
 * VmidContextProvider の子孫コンポーネントで使うこと
 */
export const useVmid = (): Vmid => {
  const vmid = useContext(VmidContext)
  if (vmid === undefined) {
    throw new Error(t('View Mount ID が undefined です'))
  }
  return vmid
}
